export default __webpack_public_path__ + "static/roadmap-line-a4d9e9684e56cd35a57e82eb4712e228.svg";